import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class SuggestionApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('classification'), options);
  }

  public parseIngredients(body: any) {
    const query = '/classification/v1/ingredient/parse';
    return this.post(query, body);
  }

  public getRealTimeFieldSuggestion(fieldmetadataName: string, data: any) {
    const route = `/classification/v2/suggestion/realtime/${fieldmetadataName}`;
    return this.post(route, data);
  }
}
